import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import axios from 'axios';
import ResponsiveAppBar from '../components/appbar';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CircularProgress from '@mui/material/CircularProgress';
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ChatIcon from '@mui/icons-material/Chat';
import Typography from '@mui/material/Typography';
import OrdForm from '../components/ordForm';
import OrdChat from '../components/ordForm';
import Cmts from '../components/cmts';
import OrdDocs from '../components/ordForm';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/provider";
import { useConfluence } from "../components/qeeConfluenceProvider"; 
import QeeNavigator from '../context/navigator';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    uiProgess: {
        position: 'fixed',
        zIndex: '1000',
        height: '31px',
        width: '31px',
        left: '50%',
        top: '35%',
    },
    toolbar: theme.mixins.toolbar,
    listItem: {
        color: '#788',
        fontWeight: 600,
        fontSize: 16,
    },
}));

const Ord = () => {
    const classes = useStyles();
    const theme = useTheme();	
    const { loadHome, loadFacs, loadAccount, loadOrds } = QeeNavigator();
    const { setOpenConfluenceDialog } = useConfluence();
    const { gstate, setCurrSubpage, setObjEdit, setObjErrors, setIsLoading, setOpenQeeDialog } = useAuth();
    const [username, setUsername] = useState(null);
    const [ordId, setOrdId] = useState(null);	
    const [state, setState] = useState({
        uiLoading: true,
    });
    const navigate = useNavigate();

    const loadOrd = async () => {
        console.log('--> loadOrd');
        const authToken = localStorage.getItem('AuthToken');
        if (!authToken) {
            navigate('/home');
            return;
        }

        setIsLoading(true);
        setCurrSubpage('loadOrdForm');

        const myURL = new URL(window.location);
        const id = myURL.searchParams.get('id');
		setOrdId( id)
        var sbpg = myURL.hash;
        if (sbpg) sbpg = sbpg.replace('#', '');
        if (sbpg === '') sbpg = 'loadOrdForm';

        const options = {
            url: `/api/ord/${id}`,
            method: 'get',
        };
        axios.defaults.headers.common = { Authorization: `${authToken}` };
        try {
            const { data } = await axios(options);
            const ord = data;
            console.log('data', ord);
            ord.step = 0;
            setObjEdit(ord);
            setCurrSubpage(sbpg);
            setIsLoading(false);
            console.log('<-- loadOrd');
        } catch (error) {
            setState({
                ...state,
                open: true,
                errors: error.response.data,
            });
            setObjErrors(error.response.data);
            console.log(error);
            setIsLoading(false);
            window.location.href = window.location.origin + '/home';
            console.log('<-- loadOrd ERR', error);
        }
    };

    useEffect(() => {
        var usr = JSON.parse(sessionStorage.getItem('usr'));
        if (!usr) {
            console.error('No user data!');
        }
        setUsername(usr.username);
        loadOrd();
    }, []);

    useEffect(() => {
        console.log('Ord page use effect for', gstate.currSubpage);

        if (gstate.currSubpage === 'loadOrdForm') loadOrdForm();
        if (gstate.currSubpage === 'loadOrdChat') loadOrdChat();                
        if (gstate.currSubpage === 'loadOrdCmts') loadOrdCmts();
        if (gstate.currSubpage === 'loadOrdDocs') loadOrdDocs();
        if (gstate.currSubpage === 'loadAccount') loadAccount();

        const myURL = new URL(window.location);
        myURL.hash = gstate.currSubpage;
        window.history.replaceState('data-pass', 'title', myURL);
    }, [gstate.currSubpage]);

    const loadOrdForm = () => {
        var sbpg = 'OrdForm';
        setCurrSubpage('load' + sbpg);
        setState({ render: sbpg });
        window.scrollTo(0, 0);
    };
    
    const loadOrdChat = () => {
        var sbpg = 'OrdChat';
        setCurrSubpage('load' + sbpg);
        setState({ render: sbpg });
        window.scrollTo(0, 0);
    };  

    const loadOrdCmts = () => {
        var sbpg = 'OrdCmts';
        setCurrSubpage('load' + sbpg);
        setState({ render: sbpg });
        window.scrollTo(0, 0);
    };

    const loadOrdDocs = () => {
        var sbpg = 'OrdDocs';
        setCurrSubpage('load' + sbpg);
        setState({ render: sbpg });
        window.scrollTo(0, 0);
    };

    const showConfluenceHome = () => {
        setOpenConfluenceDialog();
    };

    const showVersionInfo = () => {
        setOpenQeeDialog({ open: true, id: 'dlgVersionInfo' });
    };

    const logoutHandler = () => {
        localStorage.removeItem('AuthToken');
        navigate('/login');
    };

    const drawer = () => {
        return (
            <>
                <div className={classes.toolbar} />
                <List>
                    <ListItem button key="Ords" onClick={loadOrds}>
                        <ListItemIcon>
                            <ChecklistIcon />
                        </ListItemIcon>
                        <ListItemText
                            disableTypography
                            primary={<Typography variant="body2" className={classes.listItem}>Aktivitäten</Typography>}
                        />
                    </ListItem>
                    <Divider />
                    <ListItem button key="OrdForm" onClick={loadOrdForm}>
                        <ListItemIcon>
                            <ViewComfyIcon />
                        </ListItemIcon>
                        <ListItemText
                            disableTypography
                            primary={<Typography variant="body2" className={classes.listItem}>Überblick</Typography>}
                        />
                    </ListItem>
                    <ListItem button key="OrdChat" onClick={loadOrdChat}>
                        <ListItemIcon>
                            <ChatIcon />
                        </ListItemIcon>
                        <ListItemText
                            disableTypography
                            primary={<Typography variant="body2" className={classes.listItem}>Nachrichten</Typography>}
                        />
                    </ListItem>    
                    <ListItem button key="OrdDocs" onClick={loadOrdDocs}>
                        <ListItemIcon>
                            <TextSnippetIcon />
                        </ListItemIcon>
                        <ListItemText
                            disableTypography
                            primary={<Typography variant="body2" className={classes.listItem}>Dokumente</Typography>}
                        />
                    </ListItem>
                </List>
            </>
        );
    };

    const switchSubpage = () => {
        switch (gstate.currSubpage) {
            case 'loadOrdForm': return <OrdForm ordId={ordId} />;
            case 'loadOrdChat': return <OrdChat ord={gstate.objEdit} />;
            case 'loadOrdCmts': return <Cmts username={username} parentId={gstate.objEdit.id} />;
            case 'loadOrdDocs': return <OrdDocs />;
            default: return <OrdForm ordId={ordId}/>;
        }
    };

    const settings = [
        { nm: 'Mein Konto', fct: loadAccount, ico: <AccountBoxIcon /> },
        { nm: 'Aktivitäten', fct: loadOrds, ico: <ChecklistIcon /> },
        { nm: 'Wissensassistent', fct: showConfluenceHome, ico: <HelpOutlinedIcon /> },
        { nm: 'Logout', fct: logoutHandler, ico: <ExitToAppIcon /> },
    ];

    return (
        state.uiLoading ? (
            <div className={classes.root}>
                {state.uiLoading && <CircularProgress size={50} className={classes.uiProgess} />}
            </div>
        ) : (
            <div>
                <ResponsiveAppBar
                    className={classes.appBar}
                    drawer={drawer}
                    switchSubpage={switchSubpage}
                    pages={[]}
                    settings={settings}
                />
            </div>
        )
    );
}

export default Ord;
